module.exports = __webpack_public_path__ + "img/finveStarOrange.4354f5ea.png";